import { Model, Attr } from 'spraypaint';
import ApplicationRecord from '../ApplicationRecord';

/**
 * UsageSummary
 * need to provide filters like so:
 *
 * ?filter[start_date]=2024-01-01&filter[end_date]=2024-11-09
 */

@Model()
export default class TotalUsageSummary extends ApplicationRecord {
  static 'jsonapiType' = 'total-usage-summaries';

  static 'listHeaders'() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
      },
    ];
  }

  static 'scopeFactory'() {
    return TotalUsageSummary.includes([]);
  }

  @Attr() 'usersLoggedSixMonths': number;

  @Attr() 'usersLoggedOneYear': number;

  @Attr() 'usersLoggedTwoYears': number;

  @Attr() 'totalFaunaMedia': number;

  @Attr() 'totalTaggedFaunaMedia': number;

  @Attr() 'totalSurveyProperties': number;

  @Attr() 'surveyPropertiesWithFaunaMedia': number;

  @Attr() 'surveyPropertiesWithTaggedFaunaMedia': number;
}
